import { render, staticRenderFns } from "./documentos-vencidos.vue?vue&type=template&id=59f837b6"
import script from "./documentos-vencidos.vue?vue&type=script&lang=js"
export * from "./documentos-vencidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports